import React from "react"
import type {WireLimits, WireTotalsDaily, WireTotalsMonthly, WireLimitOverrideInfo} from "../../../../resources/account"
import {LimitOverrideType} from "../../../../resources/account"
import RangeBox from "../../../../components/RangeBox/RangeBox"
import {LimitsPageBlockHeader} from "../LimitsPageBlockHeader"
import {buildWireOverrideInfoProp, getEffectiveWireLimit} from "../helpers"

const wireLimitItems: {
	description: string
	overrideType: LimitOverrideType
	limitKey: "dailyTransfer" | "monthlyTransfer"
	softLimitKey: "dailyTransferSoft" | "monthlyTransferSoft"
	totalKey: "totalsDaily" | "totalsMonthly"
}[] = [
	{
		description: "(Daily Limit)",
		overrideType: LimitOverrideType.WireDailyTransfer,
		limitKey: "dailyTransfer",
		softLimitKey: "dailyTransferSoft",
		totalKey: "totalsDaily",
	},
	{
		description: "(Monthly Limit)",
		overrideType: LimitOverrideType.WireMonthlyTransfer,
		limitKey: "monthlyTransfer",
		softLimitKey: "monthlyTransferSoft",
		totalKey: "totalsMonthly",
	},
]

export function WireLimitsSection({
	limits,
	total,
	onEditLimit,
	override,
}: {
	limits: WireLimits
	total: {totalsDaily: WireTotalsDaily; totalsMonthly: WireTotalsMonthly}
	onEditLimit?: (limitType: LimitOverrideType) => void
	override?: WireLimitOverrideInfo
}) {
	return (
		<div className="account-limits-page-section">
			<LimitsPageBlockHeader title="Wire Limits" icon="money-transfer--business-products" />

			<div className="account-limits-page-grid">
				{wireLimitItems.map(({description, overrideType, limitKey, softLimitKey, totalKey}) => (
					<RangeBox
						key={overrideType}
						title="Transfers"
						description={description}
						className="account-limits-page-range-box"
						max={getEffectiveWireLimit(limits[limitKey], override, overrideType)}
						current={total[totalKey].transfers}
						softLimit={limits[softLimitKey]}
						onEdit={onEditLimit ? () => onEditLimit(overrideType) : undefined}
						overrideInfo={buildWireOverrideInfoProp(override, overrideType, limits[limitKey])}
					/>
				))}
			</div>
		</div>
	)
}
